<script setup lang="ts">
  interface Emits {
    (event: "update:selected", value: { text: string; value: any }): void;
  }
  interface Props {
    list: { text: string; value: any; disabled?: boolean; hide?: boolean }[];
    selected?: any;
  }
  withDefaults(defineProps<Props>(), {
    selected: "",
  });
  const emit = defineEmits<Emits>();

  const handleClickItem = (item: { text: string; value: any; disabled?: boolean }) => {
    if (!item.disabled) {
      emit("update:selected", item);
    }
  };
</script>
<template>
  <v-sheet class="popup">
    <div class="popup-list" data-testid="popup-list">
      <div
        v-for="item in list"
        :key="item.value"
        class="popup-list-item"
        :class="{ disabled: item.disabled }"
        data-testid="popup-list-item"
        @click="handleClickItem(item)"
      >
        <div>{{ item.text }}</div>
        <div>{{ selected === item.value ? "✔" : "" }}</div>
      </div>
    </div>
  </v-sheet>
</template>
<style lang="scss" scoped>
  .popup {
    background-color: rgb(var(--v-theme-monochrome-04)) !important;
  }
  .popup-list {
    padding: 8px 0;
  }
  .popup-list-item {
    padding: 8px 12px;
    cursor: pointer;
    display: flex;
    gap: 8px;
    justify-content: space-between;
    &:hover {
      background-color: rgb(var(--v-theme-monochrome-05));
    }
    &.disabled {
      color: rgb(var(--v-theme-monochrome-02));
      cursor: not-allowed;
    }
  }
</style>
